import { base64toBlob } from "../../DriverPopUp/StopImagesDialog/utils";
import { fetchPhysicalDrPdfUrl } from "../api/generatePhysicalDr";
import { PHYSICAL_DR_CONTENT } from "../content";
import { logPhysicalDrFailure, PRINT_PHYSICAL_DR_FAILED_MESSAGE } from "./physicalDrLogging";

export interface GetPhysicalDrBlobUrlOptions {
  terminalCode: string;
  routeIds: string[];
  signal?: AbortSignal;
  downloadFailureLogContext?: string;
}

export async function getPhysicalDrBlobUrl(
  options: GetPhysicalDrBlobUrlOptions
): Promise<string> {
  const {
    terminalCode,
    routeIds,
    signal,
    downloadFailureLogContext = PHYSICAL_DR_CONTENT.errors.generateFailed,
  } = options;

  const remotePdfUrl = await fetchPhysicalDrPdfUrl({
    terminalCode,
    routeIds,
    ...(signal ? { signal } : {}),
  });

  const pdfResponse = await fetch(remotePdfUrl, {
    ...(signal ? { signal } : {}),
    mode: "cors",
    cache: "no-store",
  });

  if (!pdfResponse.ok) {
    logPhysicalDrFailure(downloadFailureLogContext, {
      status: pdfResponse.status,
      statusText: pdfResponse.statusText,
      url: remotePdfUrl,
    });
    throw new Error(PRINT_PHYSICAL_DR_FAILED_MESSAGE);
  }

  const base64Pdf = await pdfResponse.text();
  const pdfBlob = base64toBlob(base64Pdf);
  return URL.createObjectURL(pdfBlob);
}
